export default __webpack_public_path__ + "static/media/p6.d7436136.jpg";